import Margin from "~/components/Margin";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Button, Input, InputSelect } from "prosperita-dumbo-react";
import "prosperita-dumbo-react/dist/style.css";

import lockIcon from "~/assets/lock.png";
import styled from "styled-components";
import { useFormik } from "formik";
import { useCallback, useEffect, useMemo, useState } from "react";
import SaveIcon from "~/assets/Save.png";

import {
  formatCEP,
  formatCPFCNPJ,
  formatPhoneNumber,
  getLabelByValue,
  onlyNumbers,
  validateEmail,
} from "~/services/utils";

import useLoading from "~/hooks/useLoading";

import { toast } from "react-toastify";
import { getErrorMessage } from "~/services/api/error";
import {
  bussinesSectorOptions,
  cnaeOptions,
  entityOptions,
  residenceOptions,
  ufOptions,
} from "~/utils/options";
import {
  getCompanyDetailsAPI,
  patchCompanyAPI,
  IPartnerCompany,
} from "~/services/api/partner";
import { getCepAPI } from "~/services/api/cep";
import { isValidFullNameCompany } from "~/services/validators";
import documentNumberValidator from "~/services/validateDocumentNumber";
import { isPast } from "date-fns";
import usePartner from "~/hooks/usePartner";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: start;
  padding: 30px 50px;
`;

const TagLup = styled.img`
  object-fit: contain;
  width: 200px;
  margin: 20px 0;
`;

const Text = styled.h4`
  color: #161616;
  font-family: "IBM Plex Sans";
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 20px;
`;

const Subtext = styled.h4`
  color: #161616;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 20px;
`;

type Values = {
  name: string;
  owner_uuid: string;
  document_number: string;
  document_type: string;
  contact_email: string;
  contact_phone: string;
  foundation_date: string;
  cnae: string;
  fantasy_name: string;
  legal_nature: string;
  municipal_registration: string;
  state_registration: string;
  website: string;
  business_sector: string;
  employer_code: string;
  b3_account: string;
  address_zip_code: string;
  address_street: string;
  address_number: string;
  address_district: string;
  address_city: string;
  address_state: string;
  address_country: string;
  address_type: string;
  finantial_info_initial_share_capital: string;
  finantial_info_net_equity: string;
  finantial_info_number_of_employees: string;
  finantial_info_average_monthly_revenue: string;
  finantial_info_average_gross_profit: string;
  finantial_info_exportation_percentage: string;
  finantial_info_suppliers_cost: string;
  finantial_info_tax_cost: string;
  finantial_info_last_12_months_revenue: string;
  finantial_info_leased_or_financed_value: string;
  finantial_info_arrangement: string;
  finantial_info_payroll_value: string;
  finantial_info_headquarters_location: string;
  finantial_info_pmv: string;
  finantial_info_funding_potential: string;
  finantial_info_late_sales_percentage: string;
  profile: string;
};

const initialValues: Values = {
  name: "",
  owner_uuid: "",
  document_number: "",
  document_type: "",
  contact_email: "",
  contact_phone: "",
  foundation_date: "",
  cnae: "",
  fantasy_name: "",
  legal_nature: "",
  municipal_registration: "",
  state_registration: "",
  website: "",
  business_sector: "",
  employer_code: "",
  b3_account: "",
  address_zip_code: "",
  address_street: "",
  address_number: "",
  address_district: "",
  address_city: "",
  address_state: "",
  address_country: "",
  address_type: "",
  finantial_info_initial_share_capital: "",
  finantial_info_net_equity: "",
  finantial_info_number_of_employees: "",
  finantial_info_average_monthly_revenue: "",
  finantial_info_average_gross_profit: "",
  finantial_info_exportation_percentage: "",
  finantial_info_suppliers_cost: "",
  finantial_info_tax_cost: "",
  finantial_info_last_12_months_revenue: "",
  finantial_info_leased_or_financed_value: "",
  finantial_info_arrangement: "",
  finantial_info_payroll_value: "",
  finantial_info_headquarters_location: "",
  finantial_info_pmv: "",
  finantial_info_funding_potential: "",
  finantial_info_late_sales_percentage: "",
  profile: "",
};

  const EditContactCompany = () => {
  const navigate = useNavigate();
  const [errorCep, setErrorCep] = useState<boolean>(false);
  const { setLoading } = useLoading();
  const [error, setError] = useState<string>("");
    const [fieldErrors, setFieldErrors] = useState<Record<string, boolean>>({});
    const [fieldErrorMessages, setFieldErrorMessages] = useState<Record<string, string>>({});

  const { values, setFieldValue } = useFormik({
    initialValues,
    onSubmit: () => undefined,
  });

  const { setPartner, partner } = usePartner();
  const { uuid } = useParams();

  const canDoSimulations = true;

  const isValidCNPJ = useMemo(() => {
    return (
      values.document_number.length > 13 &&
      documentNumberValidator(values.document_number)
    );
  }, [values.document_number]);

  const validateRequiredFields = useCallback((): boolean => {
    const errors: Record<string, boolean> = {};
    const messages: Record<string, string> = {};
    const fieldOrder = [
      "document_number",
      "name",
      "fantasy_name",
      "legal_nature",
      "foundation_date",
      "cnae",
      "business_sector",
      "contact_email",
      "contact_phone",
      "address_zip_code",
      "address_street",
      "address_number",
      "address_district",
      "address_city",
      "address_state",
      "address_type",
    ];

    if (!values.document_number) errors.document_number = true;

    if (!values.name?.trim()) {
      errors.name = true;
      messages.name = "campo obrigatório";
    } else if (!isValidFullNameCompany(values.name)) {
      errors.name = true;
      messages.name = "Razão social inválida";
    }
    if (!values.fantasy_name?.trim()) errors.fantasy_name = true;
    if (!values.legal_nature) errors.legal_nature = true;
    if (!values.foundation_date) errors.foundation_date = true;
    if (!values.cnae) errors.cnae = true;
    if (!values.business_sector) errors.business_sector = true;

    if (!values.contact_email?.trim()) {
      errors.contact_email = true;
    } else if (!validateEmail(values.contact_email)) {
      errors.contact_email = true;
      messages.contact_email = "E-mail inválido";
    }

    const phoneDigits = onlyNumbers(values.contact_phone || "");
    if (!phoneDigits) {
      errors.contact_phone = true;
    } else if (phoneDigits.length !== 11 || phoneDigits[2] !== "9") {
      errors.contact_phone = true;
      messages.contact_phone = phoneDigits.length !== 11 ? "Celular incompleto" : "Celular inválido";
    }

    const cepDigits = onlyNumbers(values.address_zip_code || "");
    if (cepDigits.length !== 8) {
      errors.address_zip_code = true;
      messages.address_zip_code = "CEP inválido";
    }
    if (!values.address_street?.trim()) errors.address_street = true;
    if (!values.address_number?.trim()) errors.address_number = true;
    if (!values.address_district?.trim()) errors.address_district = true;
    if (!values.address_city?.trim()) errors.address_city = true;
    if (!values.address_state) errors.address_state = true;
    if (!values.address_type) errors.address_type = true;

    if (values.foundation_date) {
      const year = Number(values.foundation_date.slice(0, 4));
      if (values.foundation_date.length > 9 && !isPast(values.foundation_date)) {
        errors.foundation_date = true;
        messages.foundation_date = "A data de fundação não pode ser uma data futura";
      } else if (!Number.isFinite(year) || year < 1900) {
        errors.foundation_date = true;
        messages.foundation_date = "Data inválida";
      }
    }

    setFieldErrors(errors);
    setFieldErrorMessages(messages);

    if (Object.keys(errors).length > 0) {
      const firstErrorField = fieldOrder.find((f) => errors[f]);
      if (firstErrorField) {
        setTimeout(() => {
          let fieldElement = document.querySelector(`[name="${firstErrorField}"]`);
          if (!fieldElement) {
            const allInputs = document.querySelectorAll("input, select");
            for (const input of Array.from(allInputs)) {
              const name = input.getAttribute("name");
              if (name === firstErrorField) {
                fieldElement = input.closest("div") || input;
                break;
              }
            }
          }
          if (fieldElement) {
            (fieldElement as HTMLElement).scrollIntoView({ behavior: "smooth", block: "center" });
            const inputElement =
              (fieldElement as HTMLElement).querySelector("input") ||
              (fieldElement as HTMLElement).querySelector("select") ||
              ((fieldElement as HTMLElement).tagName === "INPUT" || (fieldElement as HTMLElement).tagName === "SELECT"
                ? (fieldElement as HTMLElement)
                : null);
            if (inputElement) (inputElement as HTMLElement).focus();
          }
        }, 100);
      }
      return false;
    }

    return true;
  }, [values]);

  const submitEditContactCompany = useCallback(async () => {
    const payload = {
      name: values.name,

      contact: {
        email: values.contact_email,
        phone: onlyNumbers(values.contact_phone),
      },
      foundation_date: values.foundation_date,
      cnae: values.cnae,
      fantasy_name: values.fantasy_name,
      legal_nature: values.legal_nature,
      municipal_registration: values.municipal_registration,
      state_registration: values.state_registration,
      website: values.website,
      business_sector: values.business_sector,
      employer_code: values.employer_code,
      b3_account: values.b3_account,
      address: {
        zip_code: onlyNumbers(values.address_zip_code),
        street: values.address_street,
        number: values.address_number,
        district: values.address_district,
        city: values.address_city,
        state: values.address_state,
        country: values.address_country || "Brasil",
        type: values.address_type,
      },
    };

    setLoading(true);

    try {
      const { data } = await patchCompanyAPI(payload, String(uuid));

      localStorage.setItem("@:partner_uuid", data.payload.uuid);
      toast.success("Dados atualizados com sucesso");
      setLoading(false);
      navigate(`/app/contacts`);
    } catch (e) {
      console.log(e);
      setLoading(false);
      toast.error(
        getErrorMessage(
          e,
          `Não foi possível atualizar os dados. Tente novamente mais tarde`
        )
      );
    }
  }, [values, setLoading, navigate, uuid]);

  const handleSave = useCallback(async () => {
    if (!validateRequiredFields()) return;
    await submitEditContactCompany();
  }, [validateRequiredFields, submitEditContactCompany]);

  const fetchPartner = useCallback(async () => {
    setPartner(null);
    setLoading(true);
    try {
      if (uuid) {
        const { data } = await getCompanyDetailsAPI(uuid);

        setPartner(data.payload);

        setLoading(false);
      } else {
        console.error("UUID is undefined");
        setLoading(false);
      }
    } catch (err) {
      console.error("Erro ao buscar detalhes da operação:", err);
      setLoading(false);
    }
  }, [uuid, setLoading, setPartner]);

  const fetchCEP = useCallback(
    async (cep: string): Promise<void> => {
      try {
        const { data } = await getCepAPI(cep);

        if (data.erro) {
          setErrorCep(true);
          setFieldValue("address_street", "");
          setFieldValue("address_district", "");
          setFieldValue("address_city", "");
          setFieldValue("address_state", "");
        } else {
          setErrorCep(false);
          setFieldValue("address_street", data.logradouro);
          setFieldValue("address_district", data.bairro);
          setFieldValue("address_city", data.localidade);
          setFieldValue("address_state", data.uf);
          setFieldErrors((prev) => ({
            ...prev,
            address_zip_code: false,
            address_street: false,
            address_district: false,
            address_city: false,
            address_state: false,
          }));
        }
      } catch (e) {
        console.error("Erro ao buscar contatos:", e);
        setErrorCep(false);
      }
    },
    [setFieldValue]
  );

  useEffect(() => {
    if (partner) {
      const companyPartner = partner as IPartnerCompany;

      setFieldValue("name", companyPartner.name);
      setFieldValue(
        "document_number",
        formatCPFCNPJ(companyPartner.document_number)
      );
      setFieldValue("document_type", companyPartner.document_type);
      setFieldValue("contact_email", companyPartner.contact.email);
      setFieldValue(
        "contact_phone",
        formatPhoneNumber(companyPartner.contact.phone)
      );
      setFieldValue("foundation_date", companyPartner.foundation_date);
      setFieldValue("cnae", companyPartner.cnae);
      setFieldValue("fantasy_name", companyPartner.fantasy_name);
      setFieldValue("legal_nature", companyPartner.legal_nature);
      setFieldValue(
        "municipal_registration",
        companyPartner.municipal_registration
      );
      setFieldValue("state_registration", companyPartner.state_registration);
      setFieldValue("website", companyPartner.website);
      setFieldValue("business_sector", companyPartner.business_sector);
      setFieldValue("employer_code", companyPartner.employer_code);
      setFieldValue("b3_account", companyPartner.b3_account);
      setFieldValue(
        "address_zip_code",
        formatCEP(companyPartner?.address?.zip_code)
      );
      setFieldValue("address_street", companyPartner.address?.street);
      setFieldValue("address_number", companyPartner.address?.number);
      setFieldValue("address_district", companyPartner.address?.district);
      setFieldValue("address_city", companyPartner.address?.city);
      setFieldValue("address_state", companyPartner.address?.state);
      setFieldValue("address_country", companyPartner.address?.country);
      setFieldValue("address_type", companyPartner.address?.type);
    }
  }, [partner, setFieldValue]);

  useEffect(() => {
    if (values.address_zip_code?.length === 9) {
      fetchCEP(onlyNumbers(values.address_zip_code));
    }
  }, [values.address_zip_code, fetchCEP]);

  useEffect(() => {
    if (values.address_zip_code?.length === 8) {
      setErrorCep(false);
    }
  }, [values.address_zip_code]);

  useEffect(() => {
    localStorage.removeItem("@:partner_uuid");
    fetchPartner();
  }, [fetchPartner]);

  useEffect(() => {
    if (values.document_number?.length <= 17 && !isValidCNPJ) {
      setError("initialState");
    } else if (values.document_number?.length >= 17 && isValidCNPJ) {
      setError("notError");
    } else if (values.document_number?.length > 17 && !isValidCNPJ) {
      setError("CNPJ inválido");
    }
  }, [values.document_number, setError, isValidCNPJ]);

  return (
    <Container>
      <Breadcrumb
        crumbsOptions={[
          {
            crumb: "Contatos",
            onClick: () => navigate("/app/contacts"),
          },
          { crumb: "Editar" },
        ]}
        endHiddenIndex={5}
        startHiddenIndex={5}
      />

      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        ></div>
      </div>
      <div style={{ width: "100%" }}>
        <>
          {canDoSimulations && (
            <>
              <>
                <Margin mb={30} />
                <div
                  style={{
                    position: "sticky",
                    top: 113,

                    gap: "10px",
                    width: "100%",
                    zIndex: "3",
                    padding: "10px",
                    background: "#fff",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      kind={"ghost"}
                      label="Cancelar"
                      size="large"
                      onClick={() => navigate("/app/contacts")}
                    />
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Button
                        kind="primary"
                        label="Salvar"
                        icon={SaveIcon}
                        disabled={false}
                        size="large"
                        onClick={handleSave}
                      />
                    </div>
                  </div>

                  <Margin mb={10} />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <Margin mb={30} />
                    <Text style={{ fontSize: "25px" }}>
                      Editar contato Pessoa Jurídica{" "}
                    </Text>
                    <Margin mb={20} />
                    <h4>Dados da empresa</h4>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "1fr 2fr 1fr",
                    gap: "32px",
                    rowGap: "30px",
                    marginTop: "20px",
                  }}
                >
                  <>
                    <Input
                      size="large"
                      name="document_number"
                      label="CNPJ (Obrigatório)"
                      placeholder="00.000.000/0000-00"
                      value={values.document_number}
                      maxLength={18}
                      disabled
                      error={values.document_number.length > 17 && !isValidCNPJ}
                      message={
                        values.document_number.length > 17 && !isValidCNPJ
                          ? error
                          : ""
                      }
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/[^\d]/g, "");
                        if (value.length <= 2) {
                          value = `${value}`;
                        } else if (value.length <= 5) {
                          value = `${value.slice(0, 2)}.${value.slice(2)}`;
                        } else if (value.length <= 8) {
                          value = `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5)}`;
                        } else if (value.length <= 12) {
                          value = `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5, 8)}/${value.slice(8)}`;
                        } else if (value.length <= 14) {
                          value = `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5, 8)}/${value.slice(8, 12)}-${value.slice(12)}`;
                        }

                        setFieldValue("document_number", value);
                      }}
                    />
                    <Input
                      size="large"
                      name="name"
                      label="Razão Social (Obrigatório)"
                      placeholder="Digite"
                      value={values.name}
                      error={fieldErrors.name}
                      message={
                        fieldErrors.name
                          ? fieldErrorMessages.name || "campo obrigatório"
                          : ""
                      }
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setFieldValue("name", newValue);

                        // Se o usuário começou a digitar algo válido, limpar erros
                        if (newValue.trim() && isValidFullNameCompany(newValue)) {
                          setFieldErrors((p) => ({ ...p, name: false }));
                          setFieldErrorMessages((p) => ({ ...p, name: "" }));
                        }
                      }}
                    />
                    <Input
                      size="large"
                      name="fantasy_name"
                      label="Nome Fantasia (Obrigatório)"
                      placeholder="Digite"
                      required
                      value={values.fantasy_name}
                      error={fieldErrors.fantasy_name}
                      message={fieldErrors.fantasy_name ? "campo obrigatório" : ""}
                      onChange={(e) =>
                        setFieldValue("fantasy_name", e.target.value)
                      }
                    />
                  </>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "32px",
                    rowGap: "30px",
                    marginTop: "20px",
                  }}
                >
                  <>
                    <div>
                      <InputSelect
                        size="small"
                        kind="default"
                        name="legal_nature"
                        value=""
                        placeholder={
                          values.legal_nature
                            ? getLabelByValue(
                                values.legal_nature,
                                entityOptions
                              )
                            : "Escolha uma opção"
                        }
                        label="Natureza Jurídica (Obrigatório)"
                        options={entityOptions}
                        error={fieldErrors.legal_nature}
                        message={fieldErrors.legal_nature ? "campo obrigatório" : ""}
                        onChange={(e) => {
                          setFieldValue("legal_nature", e.value);
                          if (fieldErrors.legal_nature && e.value) {
                            setFieldErrors((p) => ({ ...p, legal_nature: false }));
                          }
                        }}
                      />
                    </div>
                    <Input
                      size="large"
                      type="date"
                      name="foundation_date"
                      label="Data de abertura (Obrigatório)"
                      placeholder="dd/mm/aaaa"
                      error={fieldErrors.foundation_date}
                      message={
                        fieldErrors.foundation_date
                          ? fieldErrorMessages.foundation_date || "campo obrigatório"
                          : ""
                      }
                      value={values.foundation_date}
                      onChange={(e) => {
                        setFieldValue("foundation_date", e.target.value);
                        if (fieldErrors.foundation_date && e.target.value) {
                          setFieldErrors((p) => ({ ...p, foundation_date: false }));
                          setFieldErrorMessages((p) => ({ ...p, foundation_date: "" }));
                        }
                      }}
                    />
                    <div>
                      <InputSelect
                        size="small"
                        kind="default"
                        name="cnae"
                        label="CNAE (Obrigatório)"
                        value=""
                        placeholder={
                          values.business_sector
                            ? getLabelByValue(values.cnae, cnaeOptions)
                            : "Escolha uma opção"
                        }
                        options={cnaeOptions}
                        onChange={(e) => setFieldValue("cnae", e.value)}
                      />
                    </div>
                    <div>
                      <InputSelect
                        size="small"
                        kind="default"
                        name="business_sector"
                        label="Ramo de atividade (Obrigatório)"
                        value=""
                        placeholder={
                          values.business_sector
                            ? getLabelByValue(
                                values.business_sector,
                                bussinesSectorOptions
                              )
                            : "Escolha uma opção"
                        }
                        options={bussinesSectorOptions}
                        onChange={(e) =>
                          setFieldValue("business_sector", e.value)
                        }
                      />
                    </div>
                    <Input
                      max={20}
                      maxLength={20}
                      size="large"
                      name="municipal_registration"
                      label="Inscrição Municipal"
                      placeholder="00000000000"
                      value={values.municipal_registration}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setFieldValue("municipal_registration", value);
                      }}
                    />
                    <Input
                      max={20}
                      maxLength={20}
                      size="large"
                      name="state_registration"
                      label="Inscrição Estadual"
                      placeholder="00000000000"
                      value={values.state_registration}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setFieldValue("state_registration", value);
                      }}
                    />

                    <Input
                      size="large"
                      name="website"
                      label="Website"
                      placeholder="Digite"
                      value={values.website}
                      onChange={(e) => setFieldValue("website", e.target.value)}
                    />
                    <Input
                      max={25}
                      maxLength={25}
                      size="large"
                      name="b3_account"
                      label="Conta B3"
                      placeholder="Digite"
                      value={values.b3_account}
                      onChange={(e) =>
                        setFieldValue("b3_account", e.target.value)
                      }
                    />
                  </>
                </div>
                <Margin mt={50} />
              </>
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <h4>Dados de contato</h4>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    gap: "32px",
                    rowGap: "30px",
                    marginTop: "20px",
                  }}
                >
                  <>
                    <Input
                      size="large"
                      name="contact_email"
                      label="E-mail (Obrigatório)"
                      placeholder="contato@mail.com"
                      value={values.contact_email}
                      error={
                        fieldErrors.contact_email ||
                        (!!values.contact_email && !validateEmail(values.contact_email))
                      }
                      message={
                        fieldErrors.contact_email
                          ? fieldErrorMessages.contact_email || "campo obrigatório"
                          : !!values.contact_email && !validateEmail(values.contact_email)
                          ? values.contact_email.length < 5
                            ? "E-mail incompleto"
                            : "E-mail inválido"
                          : ""
                      }
                      onChange={(e) => {
                        setFieldValue("contact_email", e.target.value);
                        if (fieldErrors.contact_email && e.target.value.trim() !== "") {
                          setFieldErrors((p) => ({ ...p, contact_email: false }));
                          setFieldErrorMessages((p) => ({ ...p, contact_email: "" }));
                        }
                      }}
                    />
                    <Input
                      size="large"
                      maxLength={15}
                      name="contact_phone"
                      label="Celular (Obrigatório)"
                      placeholder="(00) 00000-0000"
                      value={values.contact_phone}
                      error={
                        fieldErrors.contact_phone ||
                        (!!values.contact_phone &&
                          (onlyNumbers(values.contact_phone).length !== 11 ||
                            onlyNumbers(values.contact_phone)[2] !== "9"))
                      }
                      message={
                        fieldErrors.contact_phone
                          ? fieldErrorMessages.contact_phone || "campo obrigatório"
                          : !!values.contact_phone &&
                            onlyNumbers(values.contact_phone).length < 11
                          ? "Celular incompleto"
                          : !!values.contact_phone &&
                            onlyNumbers(values.contact_phone).length === 11 &&
                            onlyNumbers(values.contact_phone)[2] !== "9"
                          ? "Celular inválido"
                          : ""
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^\d]/g, "");
                        if (value.length > 0 && value.length <= 2) {
                          value = `(${value}`;
                        } else if (value.length > 2 && value.length <= 6) {
                          value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
                        } else if (value.length > 6) {
                          value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
                        }

                        setFieldValue("contact_phone", value);
                        if (fieldErrors.contact_phone && value) {
                          setFieldErrors((p) => ({ ...p, contact_phone: false }));
                          setFieldErrorMessages((p) => ({ ...p, contact_phone: "" }));
                        }
                      }}
                    />
                  </>
                </div>
                <Margin mt={50} />
              </>
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <h4>Endereço</h4>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "32px",
                    rowGap: "30px",
                    marginTop: "20px",
                  }}
                >
                  <>
                    <Input
                      size="large"
                      name="address_zip_code"
                      max={9}
                      maxLength={9}
                      label="CEP (Obrigatório)"
                      placeholder="Digite"
                      value={values.address_zip_code}
                      error={
                        fieldErrors.address_zip_code ||
                        (errorCep && values.address_zip_code.length === 9)
                      }
                      message={
                        fieldErrors.address_zip_code
                          ? fieldErrorMessages.address_zip_code || "campo obrigatório"
                          : errorCep && values.address_zip_code.length === 9
                          ? "CEP inválido"
                          : ""
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^\d]/g, "");

                        if (value.length <= 5) {
                          value = `${value.slice(0, 5)}`;
                        } else if (value.length <= 8) {
                          value = `${value.slice(0, 5)}-${value.slice(5, 8)}`;
                        }

                        setFieldValue("address_zip_code", value);
                        if (fieldErrors.address_zip_code && value) {
                          setFieldErrors((p) => ({ ...p, address_zip_code: false }));
                          setFieldErrorMessages((p) => ({ ...p, address_zip_code: "" }));
                        }
                      }}
                    />
                    <div style={{ gridColumn: "span 2" }}>
                      <Input
                        size="large"
                        name="address_street"
                        label="Endereço (Obrigatório)"
                        disabled={!values.address_zip_code}
                        placeholder="Digite"
                        value={values.address_street}
                      error={fieldErrors.address_street}
                      message={fieldErrors.address_street ? "campo obrigatório" : ""}
                      onChange={(e) => {
                        setFieldValue("address_street", e.target.value);
                        if (fieldErrors.address_street && e.target.value.trim() !== "") {
                          setFieldErrors((p) => ({ ...p, address_street: false }));
                        }
                      }}
                      />
                    </div>
                    <Input
                      size="large"
                      name="address_number"
                      label="Número (Obrigatório)"
                      placeholder="Digite"
                      disabled={!values.address_zip_code}
                      value={values.address_number}
                      error={fieldErrors.address_number}
                      message={fieldErrors.address_number ? "campo obrigatório" : ""}
                      onChange={(e) => {
                        setFieldValue("address_number", e.target.value);
                        if (fieldErrors.address_number && e.target.value.trim() !== "") {
                          setFieldErrors((p) => ({ ...p, address_number: false }));
                        }
                      }}
                    />
                    <Input
                      size="large"
                      name="address_district"
                      label="Bairro (Obrigatório)"
                      placeholder="Digite"
                      disabled={!values.address_zip_code}
                      value={values.address_district}
                      error={fieldErrors.address_district}
                      message={fieldErrors.address_district ? "campo obrigatório" : ""}
                      onChange={(e) => {
                        setFieldValue("address_district", e.target.value);
                        if (fieldErrors.address_district && e.target.value.trim() !== "") {
                          setFieldErrors((p) => ({ ...p, address_district: false }));
                        }
                      }}
                    />
                    <Input
                      size="large"
                      name="address_city"
                      label="Cidade (Obrigatório)"
                      placeholder="Digite"
                      disabled={!values.address_zip_code}
                      value={values.address_city}
                      error={fieldErrors.address_city}
                      message={fieldErrors.address_city ? "campo obrigatório" : ""}
                      onChange={(e) => {
                        setFieldValue("address_city", e.target.value);
                        if (fieldErrors.address_city && e.target.value.trim() !== "") {
                          setFieldErrors((p) => ({ ...p, address_city: false }));
                        }
                      }}
                    />
                    <div>
                      <InputSelect
                        size="small"
                        kind="default"
                        name="address_state"
                        disabled={!values.address_zip_code}
                        label="Estado (Obrigatório)"
                        placeholder={
                          values.address_state ? values.address_state : "UF"
                        }
                        options={ufOptions}
                        error={fieldErrors.address_state}
                        message={fieldErrors.address_state ? "campo obrigatório" : ""}
                        onChange={(e) => {
                          setFieldValue("address_state", e.value);
                          if (fieldErrors.address_state && e.value) {
                            setFieldErrors((p) => ({ ...p, address_state: false }));
                          }
                        }}
                      />
                    </div>
                    <div>
                      <InputSelect
                        size="small"
                        kind="default"
                        disabled={!values.address_zip_code}
                        name="address_type"
                        label="Tipo de residência (Obrigatório)"
                        placeholder={
                          values.address_type
                            ? getLabelByValue(
                                values.address_type,
                                residenceOptions
                              )
                            : "Escolha uma opção"
                        }
                        options={residenceOptions}
                        error={fieldErrors.address_type}
                        message={fieldErrors.address_type ? "campo obrigatório" : ""}
                        onChange={(e) => {
                          setFieldValue("address_type", e.value);
                          if (fieldErrors.address_type && e.value) {
                            setFieldErrors((p) => ({ ...p, address_type: false }));
                          }
                        }}
                      />
                    </div>
                  </>
                </div>
                <Margin mt={50} />
              </>
            </>
          )}
        </>

        {!canDoSimulations && (
          <>
            <div>
              <Margin mt={70} />
              <TagLup src={lockIcon} />
              <Margin mt={30} />
              <Text>Acesso restrito</Text>

              <Subtext>
                Você não tem permissão para editar contatos <br /> contate o
                administrador do sistema para mais informações.
              </Subtext>
            </div>
          </>
        )}
      </div>
    </Container>
  );
};

export default EditContactCompany;
